import EventCategoryContainer from "components/eventCategory/EventCategoryContainer";

export default function ExhibitorCategoryPage() {
  return <EventCategoryContainer />;
}
